module.exports = __webpack_public_path__ + "img/VirtualCapabilities_00076.1342b173.jpg";